import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchAiRecruiterLogTableAndFilterSchema } from "model/AiRecruiterLogModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const AiRecruiterLogContext = createContext();

/**
 * Mirrors `JobCategoryContext` / `TaskBucketContext`: metadata loaded once via
 * `fetchMetadataSchema`, stored for table columns (+ optional server filter definitions).
 */
export const AiRecruiterLogProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [aiRecruiterLogContextData, setAiRecruiterLogContextData] = useState();
  const [aiRecruiterLogSchemaVersion, setAiRecruiterLogSchemaVersion] = useState();

  const fetchAiRecruiterLogContextData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchMetadataSchema("metadata:aiRecruiterLog", () =>
        fetchAiRecruiterLogTableAndFilterSchema([])
      );
      if (response?.success === false) {
        setError(response?.message || "Unable to fetch AI recruiter log metadata");
      } else {
        const data = response?.data ?? response;
        if (data && typeof data === "object") {
          setAiRecruiterLogContextData(data);
          setAiRecruiterLogSchemaVersion(response?.schemaVersion);
        }
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AiRecruiterLogContext.Provider
      value={{
        fetchAiRecruiterLogContextData,
        aiRecruiterLogContextData,
        aiRecruiterLogSchemaVersion,
        loading,
        error,
      }}
    >
      {children}
    </AiRecruiterLogContext.Provider>
  );
};

export const useAiRecruiterLogContext = () => useContext(AiRecruiterLogContext);
